import moment from 'moment';
import {
  passengerCount,
  getAncillaryNameInsurance,
  getDtd,
  getFareType,
} from '../../../../utilities/helpers';
import PI from '../../../../constants/personalized-insurance-types';
import { sendAncillaryEventToCustomerIO } from '../../../../utilities/customer-io-ancillary-events';
import { get } from 'lodash';

export default (pnrInfo, ancillariesData, ancillaryOfferCollectionModel, ancillaryMybDescriptions, isUpgAvailable, minCPPrice, isSignIn, isFullPaidFlyGreen, totalCPPointsCheap, desde, dataBaggage) => {
  const items = [];
  let tripType = 'MC';
  const segments = [];
  let zone = 'NA';
  const legCollection = pnrInfo?.legCollection || [];
  const outboundSegments = legCollection?.[0]?.segmentsCollection || [];
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection || [];
  let stopNumbers = 0;

  if (pnrInfo?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrInfo?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  if (legCollection?.length > 0) {
    legCollection.forEach((element) => {
      const data = element?.segmentsCollection;
      stopNumbers = data?.length > 1 ? stopNumbers + (data?.length - 1) : stopNumbers;
      data.forEach((segmentsData) => {
        segments.push(segmentsData);
      });
    });
  }

  const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
  const transactionDate = moment(pnrInfo?.creationDate);
  const apiItem = apiDepartureDate.diff(transactionDate, 'days');
  const dtd = getDtd(segments?.[0]?.departureDateTime);
  const inboundDepartureDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const apItemRanges = [
    { min: 0, max: 2, range: '0 a 2' },
    { min: 3, max: 6, range: '3 a 6' },
    { min: 7, max: 13, range: '7 a 13' },
    { min: 14, max: 20, range: '14 a 20' },
    { min: 21, max: 27, range: '21 a 27' },
    { min: 28, max: 49, range: '28 a 49' },
    { min: 50, max: 89, range: '50 a 89' },
    { min: 90, max: 119, range: '90 a 119' },
    { min: 120, max: 149, range: '120 a 149' },
    { min: 150, max: Infinity, range: '150+' },
  ];

  const apItemRange = apItemRanges.find(({ min, max }) => apiItem >= min && apiItem <= max)?.range || 'NA';

  let msItem = 0;
  if (tripType === 'RT') {
    const firstSegment = moment(segments?.[0]?.departureDateTime);
    const lastSegment = moment(segments?.[segments?.length - 1]?.arrivalDateTime);
    msItem = lastSegment.diff(firstSegment, 'days');
  }

  const marketSegments = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = (segmentCollection || []).map(segment => {
      return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');

  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';
  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}`;
  }

  const bookingClassTest = [];
  const cabinClassTest = [];
  (legCollection || []).forEach((element) => {
    const segmentsInfo = element?.segmentsCollection;
    const bookingClass = [];
    const cabinClass = [];
    (segmentsInfo || []).forEach((segmentsData) => {
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');

  const travelerCollection = pnrInfo?.cart?.travelerCollection || [];
  const travelerCount = passengerCount(travelerCollection);
  const market = pnrInfo?.globalMarketFlight;
  const marketCarrier = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = (segmentCollection || []).map(segment => {
      return `${segment?.marketingCarrier || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');

  if (market === 'DOMESTIC') {
    zone = 'DOM';
  } else if (market === 'INTERNATIONAL' || market === 'TRANSBORDER') {
    zone = 'INT';
  }

  const brandedFare = [];
  const itemName = [];
  let zoneItem = '';
  let regionItem = '';
  const departureDateTime = [];
  const outboundDepartureDateItem = [];
  let flightTimeMinutes = 0;
  (legCollection || []).forEach((legs, legIndex) => {
    const itemNameOWType = legs?.segmentsCollection?.[0]?.departureAirport + legs?.segmentsCollection?.[0]?.arrivalAirport;
    const itemNameRTType = legs?.segmentsCollection?.[0]?.departureAirport + legs?.segmentsCollection?.[1]?.arrivalAirport;
    if (tripType !== 'MC' && legIndex === 0) {
      if ((tripType === 'OW' || tripType === 'RT') && legs?.segmentsCollection?.length === 1) {
        itemName.push(itemNameOWType);
      } else {
        itemName.push(itemNameRTType);
      }
    } else if (tripType === 'MC') {
      if (legs?.segmentsCollection?.length === 1) {
        itemName.push(itemNameOWType);
      } else {
        itemName.push(itemNameRTType);
      }
    }

    const brandedFareSegments = [];
    const outboundDepartureSegments = [];
    const departureDateTimeSegments = [];
    (legs?.segmentsCollection || []).forEach((passenger, index) => {
      let brandFare = getFareType(passenger);
      if (brandFare === 'MAIN_LIGHT') {
        brandFare = 'LIGHT';
      }
      if (index === 0 && legIndex === 0 && tripType !== 'MC') {
        departureDateTime.push(moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss'));
        flightTimeMinutes = passenger?.flightDurationInMinutes;
        outboundDepartureDateItem.push(passenger?.departureDateTime?.format('YYYYMMDD'));
        brandedFare.push(brandFare);
      } else if (tripType === 'MC') {
        departureDateTimeSegments.push(moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss'));
        flightTimeMinutes += passenger?.flightDurationInMinutes;
        outboundDepartureSegments.push(passenger?.departureDateTime?.format('YYYYMMDD'));
        brandedFareSegments.push(brandFare);
      }

      if (tripType !== 'MC') {
        zoneItem = passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT';
        regionItem = passenger?.regionKeyFromLeg;
      } else if (index === legs.segmentsCollection.length - 1) {
        zoneItem = passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT';
        regionItem = passenger?.regionKeyFromLeg;
      }
    });

    if (tripType === 'MC') {
      brandedFare.push(brandedFareSegments.join('/'));
      outboundDepartureDateItem.push(outboundDepartureSegments.join('/'));
      departureDateTime.push(departureDateTimeSegments.join('/'));
    }
  });

  const upgPrices = [];
  const flyGreenPrices = [];
  (ancillariesData || []).forEach((product) => {
    if (product?.ancillary?.type === 'UPG') {
      upgPrices.push(product?.ancillary?.currency?.total);
    }

    if (product?.ancillary?.type === '09T') {
      const currencyPerSegmentArray = product?.ancillary?.currencyPerSegmentArray || [];
      currencyPerSegmentArray.forEach((segment) => {
        if (segment?.currency?.total) {
          flyGreenPrices.push(segment?.currency?.total);
        }
      });
    }
  });

  let sinUpgrade = false;
  const upsellOffer = [];
  let params = {};
  const flightTime = moment.utc(flightTimeMinutes * 60000).format('HH:mm');
  const { currentProtection } = pnrInfo.getCurrentInsurance(dataBaggage);
  const isInsurancePricePresent = !(currentProtection === PI.PLUS);
  legCollection.forEach((legs, legIndex) => {
    (legs?.segmentsCollection || []).forEach((passenger, index) => {
      const itemBrand = 'AM';
      let itemCategory = 'Ancillary';
      const marketOdItem = passenger?.departureAirport + passenger?.arrivalAirport;
      let isSeatsDataAdded = true;
      const opCarrier = passenger?.operatingCarrier;
      (ancillariesData || []).forEach((product) => {
        const ancillaries = ['AMS', 'AMK', 'DPM', 'DPI', '09T', '029', 'SVI'];
        let ancillary = product?.ancillary;
        if (!ancillary) {
          const ancillaryCollection = get(product?.carryOn, '_collection', []);
          if (ancillaryCollection?.length) {
            ancillary = ancillaryCollection[0];
          }
        }
        let itemAffiliation = 'NA';
        let itemCategory2 = 'NA';
        let price = 0;
        let pricePoints = 0;
        const quantity = 1;

        const extraBagsArray = ancillaryOfferCollectionModel && ancillaryOfferCollectionModel?.getBaggageAncillaryOffer() && ancillaryOfferCollectionModel?.getBaggageAncillaryOffer()?.getExtraBagsAsArray();
        const adminFeeArray = ancillaryOfferCollectionModel && ancillaryOfferCollectionModel?.getBaggageAncillaryOffer() && ancillaryOfferCollectionModel?.getBaggageAncillaryOffer()?.getSingleAdminFee();
        const extraBags = extraBagsArray && extraBagsArray?.length !== 0 ? extraBagsArray : adminFeeArray ? [adminFeeArray] : [];
        switch (ancillary?.type) {
          case 'AMS':
            itemCategory = 'Insurance';
            itemCategory2 = getAncillaryNameInsurance(ancillary?.type);
            itemAffiliation = 'AM';
            price = isInsurancePricePresent ? ancillary?.currency?.total : 0;
            break;
          case 'SVI':
            itemCategory = 'Insurance';
            itemCategory2 = getAncillaryNameInsurance(ancillary?.type);
            itemAffiliation = 'AM';
            price = 23.3;
            break;
          case 'AMK':
            itemCategory = 'Services';
            itemCategory2 = 'Concierge';
            itemAffiliation = 'AM';
            price = 0;
            break;
          case 'DPM':
            itemCategory = 'Services';
            itemCategory2 = 'Discount Pass Mexico';
            itemAffiliation = 'AM';
            price = 0;
            break;
          case 'DPI':
            itemCategory = 'Services';
            itemCategory2 = 'Discount Pass International';
            itemAffiliation = 'AM';
            price = 0;
            break;
          case '09T':
            itemCategory = 'Services';
            itemCategory2 = 'Fly Green';
            itemAffiliation = 'AM';
            price = !isFullPaidFlyGreen ? Math.min(...flyGreenPrices) : 0;
            break;
          case '029':
            itemCategory2 = 'CBX';
            itemAffiliation = 'AM';
            price = 0;
            break;
          case 'UPG':
            itemCategory = 'Upgrade';
            itemCategory2 = 'upgrades'; // Add this line - matches Customer.io expected values
            itemAffiliation = 'AM';
            price = Math.min(...upgPrices);
            pricePoints = isSignIn ? totalCPPointsCheap : 0;
            break;
        }

        const itemListName = 'Ancillaries';
        itemCategory2 = itemCategory2.trim();
        params = {
          'item_name': itemName.join('-') || 'NA',
          'coupon': 'NA',
          'discount': 0,
          'fop_type': 'Cash',
          'item_brand': itemBrand,
          'item_category': itemCategory,
          'item_category2': itemCategory2,
          'item_category3': 'NA',
          'item_list_name': itemListName,
          'item_affiliation': itemAffiliation,
          'price': price,
          'quantity': quantity,
          'index': index,
          'booking_fee_amrpoints': 0,
          'market_ndod_item': marketNdod || 'NA',
          'market_od_item': marketOdItem || 'NA',
          'market_segment_item': marketOdItem || 'NA',
          'zone_item': zoneItem || 'NA',
          'region_item': regionItem || 'NA',
          'flight_time_dep': departureDateTime.join('-') || 'NA',
          'flight_time': flightTime || 'NA',
          'branded_fare': brandedFare.join('-') || 'NA',
          'outbound_departure_date_item': outboundDepartureDateItem.join('-') || 'NA',
          'inbound_departure_date_item': inboundDepartureDate,
          'price_points': pricePoints,
          'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
          'aircraft_type': passenger?.aircraftType || 'NA',
          'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
          'ap_item': apItemRange,
          'op_carrier': opCarrier || 'NA',
          'ms_item': msItem,
          'cabin_item': tripType === 'MC' ? cabinClassSegment : passenger?.cabin || 'NA',
          'class_item': tripType === 'MC' ? bookingClassSegment : passenger?.bookingClass || 'NA',
        };

        if (extraBags?.length > 0 && product?.show === true) {
          itemCategory2 = 'Luggage';
          itemAffiliation = 'AM';
          price = ancillariesData?.[0]?.extraBagsLight?._collection?.[1]?.currency?.total || extraBags?.[0]?.currency?.total;
          pricePoints = minCPPrice;
          params = {
            'item_name': itemName.join('-') || 'NA',
            'coupon': 'NA',
            'discount': 0,
            'fop_type': 'Cash',
            'item_brand': itemBrand,
            'item_category': itemCategory,
            'item_category2': itemCategory2,
            'item_category3': 'NA',
            'item_list_name': itemListName,
            'item_affiliation': itemAffiliation,
            'price': desde,
            'quantity': quantity,
            'index': index,
            'booking_fee_amrpoints': 0,
            'market_ndod_item': marketNdod || 'NA',
            'market_od_item': marketOdItem || 'NA',
            'market_segment_item': marketOdItem || 'NA',
            'zone_item': zoneItem || 'NA',
            'region_item': regionItem || 'NA',
            'flight_time_dep': departureDateTime.join('-') || 'NA',
            'flight_time': flightTime || 'NA',
            'branded_fare': brandedFare.join('-') || 'NA',
            'outbound_departure_date_item': outboundDepartureDateItem.join('-') || 'NA',
            'inbound_departure_date_item': inboundDepartureDate,
            'price_points': isSignIn ? pricePoints : 0,
            'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
            'aircraft_type': passenger?.aircraftType || 'NA',
            'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
            'ap_item': apItemRange,
            'op_carrier': opCarrier || 'NA',
            'ms_item': msItem,
            'cabin_item': tripType === 'MC' ? cabinClassSegment : passenger?.cabin || 'NA',
            'class_item': tripType === 'MC' ? bookingClassSegment : passenger?.bookingClass || 'NA',
          };
          if (legIndex === 0 && index === 0) items.push(params);
        }

        if (ancillaryMybDescriptions?.SSE && isSeatsDataAdded) {
          const legs = pnrInfo?.legCollection;
          const segments = (legs || []).map(leg => leg?.segmentsCollection);
          const segmentsClone = [...segments];
          const imgSrc = ancillaryMybDescriptions?.SSE?.Image?.src;
          const totemSrc = ancillaryMybDescriptions?.SSE?.Totem?.src;
          const title = ancillaryMybDescriptions?.SSE?.title;
          const description = ancillaryMybDescriptions?.SSE?.Description;
          const headline = ancillaryMybDescriptions?.SSE?.Headline;
          pricePoints = ancillary?.currency?.totalCPPoints;

          segmentsClone.forEach(segment => {
            segment.forEach(subSegment => {
              if (pnrInfo?.cart?.upsellOffers !== null && pnrInfo?.cart?.upsellOffers) {
                (pnrInfo?.cart?.upsellOffers || []).forEach(offer => {
                  if (subSegment?.segmentCode === offer?.segmentCode && offer?.upgradeAvailable !== false) {
                    upsellOffer.push(subSegment);
                  }
                });
              }
            });
          });

          upsellOffer.forEach(offer => {
            if (!offer?.fareFamily?.includes('PREMIER')) {
              sinUpgrade = false;
            } else {
              sinUpgrade = true;
            }
          });

          if ((headline && title && totemSrc && description && imgSrc && !sinUpgrade && upsellOffer?.length !== 0) || !isUpgAvailable) {
            itemCategory = 'Ancillary';
            itemCategory2 = 'Seat Selection';
            itemAffiliation = 'AM';
            price = 0;
          }

          params = {
            'item_name': itemName.join('-') || 'NA',
            'coupon': 'NA',
            'discount': 0,
            'fop_type': 'Cash',
            'item_brand': itemBrand,
            'item_category': itemCategory,
            'item_category2': itemCategory2,
            'item_category3': 'NA',
            'item_list_name': itemListName,
            'item_affiliation': itemAffiliation,
            'price': price,
            'quantity': quantity,
            'index': index,
            'booking_fee_amrpoints': 0,
            'market_ndod_item': marketNdod || 'NA',
            'market_od_item': marketOdItem || 'NA',
            'market_segment_item': marketOdItem || 'NA',
            'zone_item': zoneItem || 'NA',
            'region_item': regionItem || 'NA',
            'flight_time_dep': departureDateTime.join('-') || 'NA',
            'flight_time': flightTime || 'NA',
            'branded_fare': brandedFare.join('-') || 'NA',
            'outbound_departure_date_item': outboundDepartureDateItem.join('-') || 'NA',
            'inbound_departure_date_item': inboundDepartureDate,
            'price_points': pricePoints || 0,
            'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
            'aircraft_type': passenger?.aircraftType || 'NA',
            'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
            'ap_item': apItemRange,
            'op_carrier': opCarrier || 'NA',
            'ms_item': msItem,
            'cabin_item': tripType === 'MC' ? cabinClassSegment : passenger?.cabin || 'NA',
            'class_item': tripType === 'MC' ? bookingClassSegment : passenger?.bookingClass || 'NA',
          };
          if (legIndex === 0 && index === 0) items.push(params);
          isSeatsDataAdded = false;
        }

        if ((ancillaries?.includes(ancillary?.type) || (ancillary?.type === 'UPG' && isUpgAvailable)) && legIndex === 0 && index === 0)
          items.push(params);
      });
    });
  });
  const updatedItems = items?.filter((obj, index, item) =>
    index === item?.findIndex((value) => (
      value?.item_name === obj?.item_name && value?.item_category2 === obj?.item_category2
    ))
  );

  const result = {
    event: 'view_item_list',
    ecommerce: {
      'search_filter': 'NA',
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Ancillary',
      'trip_type': tripType,
      'fop_type': 'Cash',
      'outbound_departure_date': outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone,
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegments || 'NA',
      'mkt_carrier': marketCarrier,
      'region': legCollection?.[0]?.regionKey || 'NA',
      'value_points': pnrInfo?.cart?.points || 0,
      'adults': travelerCount?.adults,
      'childs': travelerCount?.child,
      'adult_minors': travelerCount?.adultMinors,
      'infants': travelerCount?.infants,
      'stops_number': stopNumbers,
      'dtd': dtd || 'NA',
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': updatedItems,
    },
  };

  try {
    sendAncillaryEventToCustomerIO('upgrades', result, pnrInfo);
  } catch (error) {
    // Silent error
  }


  return result;
};
